import { UploadHistoryView } from "@/features/patient/records/components/UploadHistoryView";
import { useFamily } from "@/portals/patient/context/FamilyContext";

export function UploadHistoryPage() {
  const { activeDependent } = useFamily();
  return <UploadHistoryView actingAsProfileId={activeDependent?.id} />;
}
